import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import FuturePriceWarning from '@shared/components/futurePriceWarning';
import { SaasPricingTableBase } from '@shared/components';
import { connect } from 'react-redux';
import { mergeStyleSets } from '@fluentui/react';
import classNames from 'classnames';
const classes = mergeStyleSets({
    limitHeight: {
        height: '70vh'
    }
});
export const SaasPricingTableComponent = ({ app, billingCountry, onGetInNowClicked, shouldBlockPrices, config: { locale } })=>{
    var _globalThis_document;
    const [isHorizontalScrollbarPresent, setIsHorizontalScrollbarPresent] = useState(false);
    const containerRef = useRef();
    const { futurePricesInformation: futurePrices } = app;
    // In SSR context there's no body
    const bodyElement = (_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.body;
    const isDocumentScrollableVertically = (bodyElement === null || bodyElement === void 0 ? void 0 : bodyElement.scrollHeight) > (bodyElement === null || bodyElement === void 0 ? void 0 : bodyElement.clientHeight);
    return /*#__PURE__*/ _jsxs("div", {
        ref: containerRef,
        className: classNames({
            [classes.limitHeight]: isDocumentScrollableVertically && isHorizontalScrollbarPresent
        }),
        children: [
            /*#__PURE__*/ _jsx(FuturePriceWarning, {
                futurePrices: futurePrices
            }),
            /*#__PURE__*/ _jsx(SaasPricingTableBase, {
                app: app,
                billingCountry: billingCountry,
                locale: locale,
                onGetInNowClicked: onGetInNowClicked,
                shouldBlockPrices: shouldBlockPrices
            })
        ]
    });
};
const mapStateToProps = ({ config })=>({
        config
    });
export const SaasPricingTable = connect(mapStateToProps)(SaasPricingTableComponent);
